import { Stack } from "@mui/system";
import { useState } from "react";
import { T } from "react-translator-component";
import { styles } from "./styles";
import { colors } from "../common/colors";
import { Alert, Snackbar, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import appServices from "../services/app-services/appServices";
import LoadingModal from "../components/LoadingModal";
import MebukuIdUpgradeBanner from "../components/MebukuIdUpgradeBanner";
import SubmitButton from "../components/SubmitButton";
import { useSelector } from "react-redux";
import { isRegularAppUser } from "../util/utils";

export default function SuggestionBox() {
  const [desc, setDesc] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [snake, setSnake] = useState<any>("");
  const [isValid, setIsValid] = useState<boolean>(true);
  const { user } = useSelector((state: any) => state.userAuth);
  const MAX_LENGTH = 250;

  const post = async () => {
    if (desc.trim().length > 0) {
      const suggestion = {
        suggestion: {
          title: desc,
          status: "Pending",
        },
      };
      try {
        setLoading(true);
        await appServices.saveSuggestion(suggestion);
        setLoading(false);
        setDesc("");
        setIsValid(true)
        setSnake(`${T("suggestion_thank")}`);
        return true
      } catch (error: any) {
        setLoading(false);
        setIsValid(false)
        setSnake(error?.response?.data?.message ?? T("api_unknown_error"));
        return false
      }
    } else {
      return false
    }
  };

  return (
    <div style={{ marginTop: 80 }}>
      <>
        <LoadingModal
          visible={loading}
        />
        {isRegularAppUser(user) ? (
          <Stack sx={{ gab: 2 }}>
            <div
              style={{
                flexDirection: "column",
                flex: 1,
                display: "flex",
                padding: 8,
              }}
            >
              <div style={styles.communiTitle}>
                <span style={styles.communiTitleTxt}>{T("suggestion_box")}</span>
              </div>
              <p style={{ ...styles.communiTitleDescrip }}>
                {T("suggestion_description_1")}
                <br />
                {T("suggestion_description_2")}
              </p>
              <p
                style={{
                  ...styles.communiTitleDescrip,
                  color: colors.farm_gray200,
                  fontSize: 14,
                }}
              >
                {T("suggestion_description_3")}
                <br />
                {T("suggestion_description_4")}
              </p>
            </div>
            <div
              style={{
                flexDirection: "column",
                flex: 1,
                display: "flex",
                backgroundColor: colors.farm_gray15,
                padding: 8,
              }}
            >
              <span
                style={{
                  fontFamily: "mplus-1c-bold",
                  width: "100%",
                  borderBottomWidth: 2,
                  borderBottomColor: colors.farm_green200,
                  borderBottomStyle: "solid",
                  marginBottom: 8,
                }}
              >
                {T("details")}
                <span style={{ color: colors.farm_red600 }}> *&nbsp;</span>
              </span>
              <TextField
                value={desc}
                sx={{ justifyContent: "start", backgroundColor: "#FFFFFF" }}
                hiddenLabel
                multiline
                rows={7}
                inputProps={{ maxLength: MAX_LENGTH }}
                onChange={(e) => {
                  setDesc(e.target.value);
                }}
              />
              <span
                style={{
                  marginTop: -1,
                  fontFamily: "mplus-1c-regular",
                  fontSize: 10,
                  alignSelf: "end",
                  position: "relative",
                }}
              >
                {desc.length}/{MAX_LENGTH}
              </span>
              <SubmitButton
                disabled={desc.trim() === ""}
                sx={{
                  alignSelf: "center",
                  borderRadius: 20,
                  backgroundColor: colors.farm_blue200,
                  color: "white",
                }}
                size={"large"}
                variant="contained"
                endIcon={<FontAwesomeIcon icon={faChevronRight} />}
                validate={async () => desc.trim().length > 0}
                onSubmit={post}
              >
                <span style={{ minWidth: 200 }}>{T("send")}</span>
              </SubmitButton>
            </div>
            <Snackbar
              open={snake !== ""}
              autoHideDuration={3000}
              sx={{ width: "94%" }}
              onClose={() => setSnake("")}
            >
              <Alert
                onClose={() => setSnake("")}
                severity={isValid ? "success" : "error"}
                sx={{ width: "100%" }}
              >
                {snake}
              </Alert>
            </Snackbar>
          </Stack>
        ) : (
          <div
            style={{
              alignItems: "center",
              justifyContent: "center",
              alignContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <img
              style={styles.introSliderImg}
              src={require("../assets/sliderimages/community_logo.png")}
              alt=""
            />
            <p>{T("suggestion_only_regular_app_user")}</p>
            <MebukuIdUpgradeBanner />
          </div>
        )}
      </>
    </div>
  );
}
